import {View} from 'react-native';
import isFinite from 'lodash/isFinite';

import Format from '~/lib/format';

import sy from '~/styles';
import {Text, Menu} from '~/components/controls';
import PropTypes from 'prop-types';

import LooksOneIcon from '~/images/md-icons/looks_one/materialicons/24px.svg';
import LooksTwoIcon from '~/images/md-icons/looks_two/materialicons/24px.svg';
import Looks3Icon from '~/images/md-icons/looks_3/materialicons/24px.svg';
import Looks4Icon from '~/images/md-icons/looks_4/materialicons/24px.svg';
import Looks5Icon from '~/images/md-icons/looks_5/materialicons/24px.svg';
import Looks6Icon from '~/images/md-icons/looks_6/materialicons/24px.svg';
import DiscountIcon from '~/images/md-icons/discount/materialicons/24px.svg';

const LOOKS_ICONS = [
  LooksOneIcon,
  LooksTwoIcon,
  Looks3Icon,
  Looks4Icon,
  Looks5Icon,
  Looks6Icon,
];

const getLookIcon = (order, fill = '#4A4A49') => {
  if (!isFinite(order) || order < 1 || order > LOOKS_ICONS.length) {
    return null;
  }

  const Icon = LOOKS_ICONS[order - 1];
  return (
    <Icon key={`look-${order}-${fill}`} width={18} height={18} fill={fill} />
  );
};

const getDiscountLabel = ({discount, manufacturerSuggestedRetailPrice}) => {
  if (!(discount > 0 && discount < 1)) {
    return null;
  }

  return (
    <>
      <Text style={[sy.smallMedium, {color: '#FFFFFF', whiteSpace: 'nowrap'}]}>
        {Format.number((1 - discount) * 100)}% korting
      </Text>
      <Text
        style={[
          sy.smallMedium,
          sy['line-through'],
          {color: '#FFFFFF', whiteSpace: 'nowrap'},
        ]}>
        {Format.price(manufacturerSuggestedRetailPrice)}
      </Text>
    </>
  );
};

const TireTooltip = ({
  lessor,
  order,
  discount,
  manufacturerSuggestedRetailPrice,
  onDismiss,
}) => {
  if (discount <= 0 && order <= 0) {
    return null;
  }

  const hasDiscount = discount > 0 && discount < 1;
  const hasFiniteOrder = isFinite(order);

  let leadingIcon = null;
  if (!hasFiniteOrder) {
    leadingIcon = <DiscountIcon width={18} height={18} fill="#FFFFFF" />;
  } else if (hasDiscount) {
    leadingIcon = getLookIcon(order, '#FFFFFF');
  }

  return (
    <Menu
      anchor={
        hasFiniteOrder ? (
          getLookIcon(order)
        ) : (
          <DiscountIcon width={18} height={18} fill="#4A4A49" />
        )
      }
      style={{marginTop: 0}}
      contentStyle={{backgroundColor: '#6D6D6D'}}
      onDismiss={onDismiss}>
      <View
        style={[
          sy['px-2'],
          sy['flex-row'],
          sy['gap-2'],
          sy['items-center'],
          {maxWidth: 280},
        ]}>
        <View style={[sy['shrink-0']]}>{leadingIcon}</View>
        <Text style={[sy.smallMedium, sy.truncate, {color: '#FFFFFF'}]}>
          {lessor}
        </Text>
        {getDiscountLabel({discount, manufacturerSuggestedRetailPrice})}
      </View>
    </Menu>
  );
};

TireTooltip.propTypes = {
  lessor: PropTypes.string,
  order: PropTypes.any,
  discount: PropTypes.any,
  manufacturerSuggestedRetailPrice: PropTypes.any,
  onDismiss: PropTypes.func,
};

export default TireTooltip;
